import { icon } from "@fortawesome/fontawesome-svg-core";
import {FaReact,FaCss3Alt,FaGitAlt,FaGithub,FaBootstrap} from "react-icons/fa";
import {SiJavascript,SiRedux,SiHtml5,SiCss3} from "react-icons/si";
import { TbApi } from "react-icons/tb";
import { motion } from "motion/react";
import { useContext } from "react";
import { WindowSize } from "./Components/Context/WindoContext";

const skillGroups = [
  {
    title: 'Frontend',
    items: [{
            skill:"React.js",
            icon:<FaReact color="#61DAFB"/> ,
            },
            {
            skill:"JavaScript",
            icon:<SiJavascript color="#F7DF1E"/>
            },
            {
            skill:"Redux",
            icon:<SiRedux color="#764ABC"/>
            },
            {
            skill:"Bootstrap",
            icon:<FaBootstrap color="#563D7C"/>
            },
            {
            skill:"HTML5",
            icon:<SiHtml5 color="#E34C26"/>
            },
            {
            skill:"CSS3",
            icon:<FaCss3Alt color="#1572B6"/>
            },
            ],
    delay:'0.2'
  },
  {
    title: 'Development',
    items: [{
             skill:"REST API Integration",
             icon:<TbApi color="#4DB33D"/>  
            }, 
            {
              skill:"Git & GitHub",
              icon:<FaGitAlt color="#F05032"/>
            },{
              skill:"npm Package Management",
              icon:<FaGithub color="#181717"/>
            }],
    delay:'0.8'        

  },
  {
    title: 'Engineering Practices',
    items: [{
             skill:"Clean Code",
             icon:<FaReact color="#61DAFB"/> 
            }, {
              skill:"Component Architecture",
              icon:<FaReact color="#61DAFB"/> 
            }, {
              skill:"Performance Optimization",
              icon:<FaReact color="#61DAFB"/> 
            }, {
              skill:"AI-Assisted Development",
              icon:<FaReact color="#61DAFB"/> 
            }],
    delay:'1.4'       
  },
];

export default function Skills() {
    //context for media
    const mediaSize=useContext(WindowSize);
  //mapping
  const skillGroupItems = skillGroups.map((group,key) => (
          <motion.div className="skill-card" key={key}
          initial={{opacity:0, translateY:"100px" }}
          whileInView={{ opacity:1,translateY:"0"}}
          transition={{  duration: 1, 
            delay:mediaSize.windowSize<760&&key==skillGroups.length - 1?'0.2':group.delay}}
          viewport={{once:true}}>
            <h3>{group.title}</h3>
            <div className="skill-divider" />
            <ul>
              {group.items.map((item,key) => (
                <li key={key}>{item.icon} {item.skill}</li>
              ))}
            </ul>
          </motion.div>
        ))
  return (
    <section id="skills" className="section">
      <div className="section-heading">
        <h2>Skills</h2>
      
      </div>
      <div className="skills-grid">
        {skillGroupItems}
      </div>
    </section>
  );
}

